import React from 'react';
import PropTypes from 'prop-types';
import { BarChart, Bar, Cell, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { colorArray, setCurrencyFormat } from '../../../../utils/helpers';

function HorizontalChart({ data, max }) {
    return (
        <ResponsiveContainer height={50} width="99%" >
            <BarChart data={data} layout="vertical" >
                <XAxis type="number" hide domain={[0, max]} formatter={item => setCurrencyFormat(item, false)} />
                <YAxis dataKey="day" type="category" hide />
                <Tooltip formatter={item => setCurrencyFormat(item, false)} />
                <Bar dataKey="Count">
                    {data.map((entry, index) => (
                        <Cell
                            cursor="pointer"
                            fill={entry.color}
                            key={entry.id}
                        />
                    ))}
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
}

HorizontalChart.propTypes = {
    data: PropTypes.arrayOf({}).isRequired,
    max: PropTypes.number.isRequired
};


export default HorizontalChart;